// CustomButtonSubmit.js
import React from 'react';

const ButtonFilter = ({ onClick, type = "submit" }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className="w-full flex items-center justify-center rounded py-2 px-4 text-sm font-medium text-white bg-blue-600 hover:bg-blue-800 shadow-lg transition duration-200"
    >
      <span className="material-icons-outlined mr-2">filter_alt</span>
      Filtrar
    </button>
  );
};

export default ButtonFilter;
